__webpack_require__.p = "/kanban_board/";